// Select from the flat structure where reducers are at the root level
const stateRoot = state => state.group_invite_links || {};

export const getInviteLinks = state => stateRoot(state).inviteLinks || [];

export const getCurrentInviteLink = state => stateRoot(state).currentInviteLink || null;

export const getIsLoading = state => stateRoot(state).isLoading || false;

export const getIsShowingDialog = state => stateRoot(state).isShowingDialog || false;

export const getError = state => stateRoot(state).error || null;
